import React from "react";
import SkeletonElement from "./BasicSkeleton/SkeletonElement";
import SkeletonCard from "./BasicSkeleton/SkeletonCard";
import SkeletonAnimation from "./BasicSkeleton/SkeletonAnimation";

export default function SKActivityLogRow() {
  return (
    <>
      <tr className="al-rowValues">
        <td className="al-type">
          <div className="d-flex">
            <div
              className="al-typeIcon"
              style={{ width: "20px", height: "20px" }}
            >
              <SkeletonElement type="box" />
            </div>
            <div className="al-typeDesc">
              <div
                className="al-typeName"
                style={{ width: "100px", height: "20px" }}
              >
                <SkeletonElement type="box" />
              </div>
              <div className="al-typeTime">
                <div style={{ width: "90px", height: "14px" }}>
                  <SkeletonElement type="box" />
                </div>
              </div>
            </div>
          </div>
        </td>
        <td className="al-item">
          <div className="d-flex">
            <div style={{ width: "70px", height: "80px", border: "none" }}>
              <SkeletonElement type="box" />
            </div>
            <div className="al-gangstaInfo">
              <div style={{ width: "90px", height: "24px" }}>
                <SkeletonElement type="box" />
              </div>
              <div style={{ width: "40px", height: "10px" }}>
                <SkeletonElement type="box" />
              </div>
              <div style={{ width: "40px", height: "15px" }}>
                <SkeletonElement type="box" />
              </div>
            </div>
          </div>
        </td>
        <td>
          <div style={{ height: "inherit" }}>
            <div style={{ width: "90px", height: "20px" }}>
              <SkeletonElement type="box" />
            </div>
          </div>
        </td>
        <td>
          <div style={{ height: "inherit" }}>
            <div style={{ width: "90px", height: "20px" }}>
              <SkeletonElement type="box" />
            </div>
          </div>
        </td>
        <td>
          <div style={{ height: "inherit" }}>
            <div style={{ width: "60px", height: "18px" }}>
              <SkeletonElement type="box" />
            </div>
            <div style={{ width: "90px", height: "14px" }}>
              <SkeletonElement type="box" />
            </div>
          </div>
        </td>
        <td>
          <div style={{ height: "inherit" }}>
            <div style={{ width: "90px", height: "20px" }}>
              <SkeletonElement type="box" />
            </div>
          </div>
        </td>
      </tr>
    </>
  );
}
